export function hasCmdRepeated(a, b, cmdHistory) {
    return cmdHistory.a === a && cmdHistory.b === b;
}
//# sourceMappingURL=hasCmdRepeated.js.map